import "./JunkRemovalNepean.module.css";
import Header from "@/reusable_sections/Header";
import HeroNepean from "./sections/HeroNepean";
import IntroductionNepeanLocal from "./sections/IntroductionNepeanLocal";
import ServicesGrid from "./sections/ServicesGrid";
import WhyChooseUs from "./sections/WhyChooseUs";
import HowItWorks from "./sections/HowItWorks";
import LocalAreaNepean from "./sections/LocalAreaNepean";
import BeforeAfterGallery from "./sections/BeforeAfterGallery";
import FaqNepean from "./sections/FaqNepean";
import FinalCtaNepean from "./sections/FinalCtaNepean";
import Footer from "@/reusable_sections/Footer";
export default function JunkRemovalNepeanPage() {
  return <div>
      <Header />
      <HeroNepean />
      <IntroductionNepeanLocal />
      <ServicesGrid />
      <WhyChooseUs />
      <HowItWorks />
      <LocalAreaNepean />
      <BeforeAfterGallery />
      <FaqNepean />
      <FinalCtaNepean />
      <Footer />
    </div>;
}